import { createContext, useContext, useCallback } from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const ProductCatalogApiContext = createContext(null);

export function ProductCatalogApiProvider({ children }) {
    const { get, post, del, putUpload } = useApiService(CONFIG.SERVER_DOCUMENT);
    const { get: get_organization } = useApiService(CONFIG.SERVER_ORGANIZATION);

    const getCatalogs = useCallback(async (skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/e_commerce/catalogs?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (err) {
        }
    }, [get]);

    const getConnections = useCallback(async () => {
        try {
            const response = await get_organization(
              `/v1/connections`
            );
            return response.data.items;
        } catch (error) {
            console.error("Error fetching connection:", error);
            throw error;
        }
    }, [get_organization]);

    const deleteCatalog = useCallback(async (catalogId) => {
        try {
            await del(`/v1/e_commerce/catalogs/${catalogId}`);
        } catch (err) {
        }
    }, [del]);

    const uploadCatalog = useCallback(async (catalogFile) => {
        try {
            const formData = new FormData();
            formData.append("document", catalogFile);
            const response = await putUpload(`/v1/e_commerce/catalogs`, formData);
            return response.data;
        } catch (err) {
        }
    }, [putUpload]);

    const uploadConnectionCatalog = useCallback(async (catalogFile) => {
        try {
            const response = await post(`/v1/e_commerce/catalogs/connection`, catalogFile);
            return response.data;
        } catch (err) {
        }
    }, [post]);

    const getCatalogById = useCallback(async (catalogId) => {
        try {
            const response = await get(`/v1/e_commerce/catalogs/${catalogId}`);
            return response.data;
        } catch (err) {
        }
    }, [get])

    const mapCatalog = useCallback(
      async (
        catalogId,
        handleKey,
        titleKey,
        skuKey,
        attributes,
        productKeys,
        variantKeys,
        baseAddress,
        name,
      ) => {
          try {
              const payload = {
                  handle_key: handleKey,
                  title_key: titleKey,
                  sku_key: skuKey,
                  attributes: attributes,
                  product_keys: productKeys,
                  variant_keys: variantKeys,
                  base_address: baseAddress,
              };

              if (name !== undefined && name !== null) {
                  payload.name = name;
              }

              const response = await post(`/v1/e_commerce/catalogs/${catalogId}`, payload);
              return response.data?.item;
          } catch (err) {
          }
      },
      [post],
    );

    const updateCatalogTaxonomy = useCallback(
  async (catalogId, taxonomy) => {
    try {
      const response = await post(
        `/v1/e_commerce/catalogs/${catalogId}/taxonomy`,
        taxonomy,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating catalog taxonomy:", error);
      throw error;
    }
  },
  [post],
);


    return (
        <ProductCatalogApiContext.Provider value={{
            getCatalogs,
            deleteCatalog,
            uploadCatalog,
            getCatalogById,
            mapCatalog,
            getConnections,
            uploadConnectionCatalog,
            updateCatalogTaxonomy
        }}>
            {children}
        </ProductCatalogApiContext.Provider>
    );
}

export function useProductCatalogApi() {
    const context = useContext(ProductCatalogApiContext);
    if (!context) {
        throw new Error("useProductCatalogApi must be used within a ProductCatalogApiProvider");
    }
    return context;
}